/** Block Companies */
export function blockCompanies() {
  $(".companies__scroll").each(function () {
    $(this).on("click", function () {
      let section = $(this).parent();
      $("html, body").animate(
        {
          scrollTop: section.offset().top - $('header').height(),
        },
        1000
      );
    });
  });
}
